export default "__VITE_PUBLIC_ASSET__884c3524__"